/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import { Backdrop, Spacer, Text } from '@oy/ui';
import { AccentIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React, { HTMLProps } from 'react';
import { useUITranslate } from '../../../../hooks/useUITranslate';
import styles from './Loader.module.css';

type LoaderProps = {
  title?: string;
  detail?: string;
  loaderStyle?: any;
  isUsingBackdrop?: boolean;
} & HTMLProps<HTMLDivElement>;

const Loader = ({
  title,
  detail,
  loaderStyle,
  isUsingBackdrop,
}: LoaderProps) => {
  const { translate } = useUITranslate();
  const LoaderComponent = (
    <div className={classNames(styles.loaderContainer, loaderStyle)}>
      <Spacer
        vertical={Spacer.Size.XXXL}
        horizontal={Spacer.Size.XL}
        className={styles.loaderContent}
      >
        <Spacer bottom={Spacer.Size.XXL}>
          <div className={styles.spin}>
            <AccentIcon size="medium" name="loader" />
          </div>
        </Spacer>
        <Text textStyle={Text.Style.HeadingXs}>
          {title || translate('Please Wait')}
        </Text>
        {detail && (
          <Spacer top={Spacer.Size.XS}>
            <Text textStyle={Text.Style.BodyMdRegular}>{detail}</Text>
          </Spacer>
        )}
      </Spacer>
    </div>
  );

  if (isUsingBackdrop) {
    return (
      <Backdrop show>
        <div className={styles.loaderBackdropContainer}>{LoaderComponent}</div>
      </Backdrop>
    );
  }

  return LoaderComponent;
};

export default Loader;
